export interface FieldSelectOption {
  value: string | number| boolean ;
  label: string;
  shortLabel?: string;
  altShortLabel?: string;
  policy?: boolean;
  group?: boolean;
  toDate?: Date;
  fromDate?: Date;
  code?: string;
  inactive?: boolean;
}
